module.exports = __webpack_public_path__ + "static/media/120-5.1e9d5641.svg";